module.exports = __webpack_public_path__ + "img/19_87_957_ELCA_VW_LandingPage_Image1.fe5a9dea.jpg";